export const OTHER_REFERENCE_RELATIONSHIP = 'Other';
export const REFERENCE_RELATIONSHIP_DETAIL_MAX_LENGTH = 120;

export function normalizedReferenceRelationshipDetail(
  relationship: string,
  detail: unknown,
): string | undefined {
  if (relationship !== OTHER_REFERENCE_RELATIONSHIP || typeof detail !== 'string') return undefined;
  const trimmed = detail.trim();
  return trimmed || undefined;
}

export function displayedReferenceRelationship(
  relationship: string | null | undefined,
  detail: string | null | undefined,
): string {
  if (relationship !== OTHER_REFERENCE_RELATIONSHIP) return relationship ?? '—';
  const normalizedDetail = normalizedReferenceRelationshipDetail(relationship, detail);
  return normalizedDetail ? `${relationship} — ${normalizedDetail}` : relationship;
}